import {Component, inject, OnInit, ViewEncapsulation} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {Match} from '../../../../../../model/events/Match';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MatchResultPipe} from '../../../../../../pipes/match-result.pipe';
import {EventHelper} from '../../../../../shared/event/event-helper';
import {Button} from 'primeng/button';
import {ViewService} from '../../../../../shared/service/view.service';
import {LiveTickerHelper} from '../../../../helper/LiveTickerHelper';

@Component({
  selector: 'app-match-dialog-header',
  standalone: true,
  imports: [
    MatchResultPipe,
    Button,
    TranslateModule
  ],
  templateUrl: './match-dialog-header.component.html',
  styleUrl: './match-dialog-header.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class MatchDialogHeaderComponent implements OnInit
{
  public view = inject(ViewService);
  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);
  private translate = inject(TranslateService);

  title: string;
  match: Match;
  isTeamLeague: boolean;
  isTeam: boolean;
  maximized = false;

  ngOnInit(): void
  {
    if (this.config.data)
    {
      this.title = this.config.header;
      this.initTitle(this.config.data.match);
    }
  }

  close(): void
  {
    this.ref.close();
  }

  private initTitle(match: Match): void
  {
    if (match.participantHome?.displayName && match.participantGuest?.displayName)
    {
      this.match = match;
      this.isTeamLeague = EventHelper.isTeamLeague(match.event);
      this.isTeam = EventHelper.isTeam(match.event);
      console.log('initTitle: ', match);
    }
    else
    {
      this.title = this.translate.instant('MATCH_DETAILS') + ' (' +
        this.translate.instant('MATCH_NR', {value: match.gameNr}) + ')';
    }
  }

  public toggleMaximize(): void
  {
    // console.log('maximze');
    // this.ref.maximize(true);
    const dialogEl = document.querySelector('.p-dialog');
    if (!dialogEl) return;

    if (this.maximized)
      dialogEl.classList.remove('p-dialog-maximized');
    else dialogEl.classList.add('p-dialog-maximized');

    this.maximized = !this.maximized;
  }

  public showLiveticker(): void
  {
    console.log('showLivetickerTeamLeague, match: ', this.match);
    LiveTickerHelper.showLivetickerTeamLeague(this.match.dbId, this.match.id);
  }
}
